import React from "react";
import { Location } from "@navigation/Location";
import { TravelRequestPage } from "../TravelRequest/TravelRequestPage";

interface Params {
  bookingId?: string;
  bookingGroupId?: string;
  requestId?: string;
}

export class TravelRequestLocation extends Location<Params> {
  render() {
    return (
      <TravelRequestPage
        bookingId={this.params.bookingId}
        bookingGroupId={this.params.bookingGroupId}
        requestId={this.params.requestId}
      />
    );
  }

  equals(location: Location<Params>): boolean {
    return this.params.bookingId === location.params.bookingId;
  }

  toURI(): string {
    if (this.params.bookingId) {
      return `/bookings/${this.params.bookingId}/travel-request`;
    }

    return `/travel-request`;
  }
}
